import styled from 'styled-components';

/* eslint-disable */
/* stylelint-disable */
export const Label = styled.p`
  margin: 0;
  font-weight: 700;
  color: #0c0d0e;
`;
/* stylelint-enable */

export const Sublabel = styled.span`
  display: inline-block;
  margin: 2px 0 0;
  font-size: 12px;
  line-height: 15px;
  color: #0c0d0e;
`;
/* eslint-enable */
